module.exports = __webpack_public_path__ + "assets/img/solutions2.b2ece6bb.png";